import React, { useContext } from "react";
import styled from "@emotion/styled";
import { Link, useHistory } from "react-router-dom";
import { color } from "../../styles/color";
import type { SetState } from "../../client_types";
import { context } from "../context/Context";
import { GETJsonRaceLiveSetting } from "../../api";
import NavLink from "./NavLink";

const UlOutter = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 0 !important;
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: ${(props: { open: boolean }) => (props.open ? "0" : "100%")};
    top: 0;
    background-color: rgb(0, 0, 0);
    z-index: 80;
    opacity: ${(props: { open: boolean }) => (props.open ? ".4" : "0")};
    visibility: ${(props: { open: boolean }) =>
      props.open ? "visible" : "hidden"};
    transition: all 0.3s ease-out;
  }
`;
const StyledUl = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  flex-flow: column nowrap;
  position: fixed;
  overflow: hidden;
  top: 0;
  right: ${(props: { open: boolean }) => (props.open ? "0%" : "-100%")};
  width: 60vw;
  height: 100%;
  background-color: ${color.primaryBlue};
  align-items: center;
  z-index: 99;
  padding-top: 2rem;
  transition: all 0.3s ease-out 0.1s;
  li {
    list-style: none;
    margin: 1rem 2.5rem;
    color: white;
    font-size: 0.8rem;
    font-weight: 800;
  }
  .active {
    color: ${color.markedDefault};
  }
  .loginBtn {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    margin: 0;
    a {
      color: ${(props: { open: boolean }) =>
        props.open ? "white" : `${color.link}`};
    }
  }
  @media (min-width: 900px) {
    margin: 0;
    padding: 0;
    display: flex;
    flex-flow: row nowrap;
    position: relative;
    left: 0;
    width: 100%;
    height: auto;
    background-color: rgba(255, 255, 255, 0);
    li {
      list-style: none;
      margin: 0 0.25rem;
      color: ${color.default};
      transition: all 0.3s;
      &:hover {
        color: ${color.markedDefault};
      }
    }
    .loginBtn {
      display: flex;
      flex-flow: row nowrap;
      margin-left: auto;
    }
  }
`;
const Burger = styled.div`
  margin-right: 0 !important;
  padding: 0;
  width: 1.5rem;
  height: 1.5rem;
  position: fixed;
  right: 5%;
  top: 1.25rem;
  z-index: 100;
  span {
    width: 100%;
    height: 2px;
    border-radius: 4px;
    background-color: ${(props: { open: boolean }) =>
      props.open ? "white" : `${color.primaryBlue}`};
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    position: absolute;
    left: 50%;
    transition: all 0.3s ease-out;
    &:first-of-type {
      top: ${(props: { open: boolean }) => (props.open ? "50%" : "15%")};
      transform: translate(-50%, 0%)
        ${(props: { open: boolean }) =>
          props.open ? "rotate(45deg)" : "rotate(0)"};
    }
    &:nth-of-type(2) {
      top: 50%;
      transform: translate(-50%, 0%);
      opacity: ${(props: { open: boolean }) => (props.open ? "0" : "1")};
    }
    &:last-of-type {
      top: ${(props: { open: boolean }) => (props.open ? "50%" : "85%")};
      transform: translate(-50%, 0%) rotate(0)
        ${(props: { open: boolean }) =>
          props.open ? "rotate(-45deg)" : "rotate(0)"};
    }
  }
  @media (min-width: 900px) {
    display: none;
  }
`;

interface IProps {
  open: boolean;
  setOpen: SetState<boolean>;
}

const NavItems = ({ open, setOpen }: IProps) => {
  const [settings, setSettings] = React.useState([]);
  const [active, setActive] = React.useState(0);
  const { dispatch, state } = useContext(context);
  let history = useHistory();
  const settingsObj = Object.fromEntries(
    settings.map(({ settingName, settingValue }) => [settingName, settingValue])
  );
  const items = [
    {
      to: "/",
      requiredPrivilege: state.character,
      showSetting: 1,
      children: "直播成绩",
    },
    {
      to: `/scan_detail/${state.clubID || ""}`,
      requiredPrivilege: state.character,
      showSetting: Number.parseInt(settingsObj.SHOWSCANDETAILPAGE) || 1,
      children: "掃描明細",
    },
    {
      to: `/daily_record/${state.clubID || ""}`,
      requiredPrivilege: state.character,
      showSetting: 2,
      children: "每日归返",
    },
    {
      to: `/daily_total`,
      requiredPrivilege: state.character,
      showSetting: 2,
      children: "每日统计",
    },
    {
      to: `/device_list`,
      requiredPrivilege: state.character,
      showSetting: 2,
      children: "踏板清单",
    },
    {
      to: `/device_connection`,
      requiredPrivilege: state.character,
      showSetting: 2,
      children: "踏板连线状态",
    },
    {
      to: `/train_record`,
      requiredPrivilege: state.character,
      showSetting: 2,
      children: "踏板扫描设定",
    },
    {
      to: `/settings/racelive`,
      requiredPrivilege: state.character,
      showSetting: 2,
      children: "頁面設定",
    },
    {
      to: `/device_order`,
      requiredPrivilege: state.character,
      showSetting: 3,
      children: "踏板命令",
    },
  ];

  const handleLogout = () => {
    alert("已登出");
    dispatch({ __CLEAR_ALL: true });
    history.push("/login");
  };
  const onNavLinkClick = (i: number) => {
    setActive(i);
    setOpen(false);
  };
  React.useEffect(() => {
    if (state.gid) {
      GETJsonRaceLiveSetting(state.gid, "globaltopmenu").then((json) => {
        setSettings(json);
      });
    }
  }, [state.gid]);

  return (
    <UlOutter open={open}>
      <div className="mask" onClick={() => setOpen(false)}></div>
      <StyledUl open={open}>
        {items.map(({ to, requiredPrivilege, showSetting, children }, i) => (
          <NavLink
            to={to}
            requiredPrivilege={requiredPrivilege}
            showSetting={showSetting}
            onClick={() => onNavLinkClick(i)}
            className={active === i ? "active" : ""}
          >
            {children}
          </NavLink>
        ))}
        <div className="loginBtn">
          {localStorage.getItem("onAuth") === "true" ? (
            <>
              <li style={{ fontWeight: "700" }}>
                {state.loginClubID} - {localStorage.getItem("user")}
              </li>
              <Link className="login" to="/" onClick={() => handleLogout()}>
                <li>登出</li>
              </Link>
            </>
          ) : (
            <Link className="login" to="/login" onClick={() => setOpen(true)}>
              <li>登入</li>
            </Link>
          )}
        </div>
      </StyledUl>
      <Burger
        open={open}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <span></span>
        <span></span>
        <span></span>
      </Burger>
    </UlOutter>
  );
};

export default NavItems;
